<script setup lang="ts">
import { onMounted, ref } from 'vue'
import QRCode from 'qrcode'

interface Props {
  link: string
  size?: number
  backgroundColor?: string
  foregroundColor?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 120,
  backgroundColor: '#FFFFFF',
  foregroundColor: '#000000'
})

const qrCodeDataUrl = ref<string>('')

onMounted(async () => {
  try {
    qrCodeDataUrl.value = await QRCode.toDataURL(props.link, {
      width: props.size,
      margin: 2,
      color: {
        dark: props.foregroundColor,
        light: props.backgroundColor
      }
    })
  } catch (error) {
    console.error('Error generating QR code:', error)
  }
})
</script>

<template>
  <div v-if="qrCodeDataUrl" class="flex flex-col items-center">
    <img :src="qrCodeDataUrl" :alt="`QR Code for ${link}`" :width="size" :height="size" class="rounded-lg shadow-sm">
  </div>
  <div v-else class="flex items-center justify-center" :style="{ width: `${size}px`, height: `${size}px` }">
    <div class="size-6 animate-spin rounded-full border-b-2 border-primary" />
  </div>
</template>
